__turbopack_context__.v({
  "asset": "EnhancedProjectCard-module__CHEUPG__asset",
  "caption": "EnhancedProjectCard-module__CHEUPG__caption",
  "card": "EnhancedProjectCard-module__CHEUPG__card",
  "category": "EnhancedProjectCard-module__CHEUPG__category",
  "comingSoon": "EnhancedProjectCard-module__CHEUPG__comingSoon",
  "comingSoonBadge": "EnhancedProjectCard-module__CHEUPG__comingSoonBadge",
  "description": "EnhancedProjectCard-module__CHEUPG__description",
  "landscape": "EnhancedProjectCard-module__CHEUPG__landscape",
  "media": "EnhancedProjectCard-module__CHEUPG__media",
  "portrait": "EnhancedProjectCard-module__CHEUPG__portrait",
  "square": "EnhancedProjectCard-module__CHEUPG__square",
  "tag": "EnhancedProjectCard-module__CHEUPG__tag",
  "tags": "EnhancedProjectCard-module__CHEUPG__tags",
  "title": "EnhancedProjectCard-module__CHEUPG__title",
  "video": "EnhancedProjectCard-module__CHEUPG__video",
});
